import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { Tabs } from "antd";
import TemplateAdapter from "components/adapters/TemplateAdapter";
import BreadcrumbAdapter from "components/adapters/BreadcrumbAdapter";
import Consulta from "./Consulta";
import Trabalhadores from "./Trabalhadores";
import Relatorio from "./Relatorio";
import EmpresaAdesaoLogs from "./EmpresaAdesaoLogs";
import * as StatusManagerActions from "../../../../actions/StatusManagerActions";
import * as RedirectActions from "../../../../actions/RedirectActions";
const Adicionais = (props) => {
    const [tab, setTab] = useState("trabalhadores/dependentes");

    useEffect(() => {
        props.action.showManager();
        props.action.redirectClear();

        if (window.location.search) {
            let URLparams = {};
            window.location.search
                .replace("?", "")
                .split("&")
                .map((e) => {
                    e = e.split("=");
                    Object.assign(URLparams, { [e[0]]: e[1] });
                    return null;
                });
            if (URLparams.t) {
                setTab(URLparams.t);
            }
        }
    }, []);

    if (props.redirect.url) {
        return <Redirect to={props.redirect.url} />;
    }

    const items = [
        // {
        //     label: "CONSULTA",
        //     key: "consulta",
        //     children: <Consulta />,
        // },
        {
            label: "TRABALHADORES/DEPENDENTES",
            key: "trabalhadores/dependentes",
            children: <Trabalhadores />,
        },
        {
            label: "LOGS ADESÃO EMPREGADORES",
            key: "logs-adesao-empregadores",
            children: <EmpresaAdesaoLogs />,
        },
        // {
        //     label: "RELATÓRIO",
        //     key: "relatorio",
        //     children: <Relatorio />,
        // },
    ];

    return (
        <TemplateAdapter>
            <BreadcrumbAdapter
                data={[
                    {
                        titulo: "Relatório Prestadores",
                        link: "/manager/relatorios",
                    },
                    { titulo: "Adicionais" },
                ]}
            />
            <Tabs onChange={(e) => setTab(e)} items={items} activeKey={tab} />
        </TemplateAdapter>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
        managerStatus: state.managerStatus,
        redirect: state.redirectReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        action: bindActionCreators(
            {
                ...StatusManagerActions,
                ...RedirectActions,
            },
            dispatch,
        ),
    };
};

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(Adicionais),
);
